import { type Program, createPoll } from 'models';
import type { TopicDataObject } from 'models/service';
import { Modal, message } from '../../ui';
import PollForm, { type PollSubmitData } from './form/PollForm';
import { useCreatePollMutation } from './queries/mutations';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  onSuccess: (params: any) => void;
  preSelectedProgramTopic?: TopicDataObject;
  program?: Program;
};

const CreatePoll = ({ isOpened, onCancel, onSuccess, preSelectedProgramTopic, program }: P) => {
  const isProgram = Boolean(program);
  const { isPending, mutate } = useCreatePollMutation();

  const onSubmit = (values: PollSubmitData) => {
    if (isProgram) {
      mutate(
        // TODO: remove ?? '' when we fix how is poll create in community and in program
        { htmlContent: values.html_description ?? '', poll: values, textContent: values.description ?? '' },
        {
          onError() {
            message.error('Failed to create poll.');
          },
          onSuccess() {
            onSuccess(values);
            message.success('Poll was created.');
          },
        },
      );
    } else {
      onSuccess(values);
    }
  };

  return (
    <Modal isOpened={isOpened} loading={isPending} onCancel={onCancel} title="Create Poll" width="medium">
      <Modal.HugContent>
        <PollForm
          loading={isPending}
          onSubmit={onSubmit}
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Matches the BE poll payload's field names
          poll={createPoll({ programs_topic: preSelectedProgramTopic })}
          program={program}
        />
      </Modal.HugContent>
    </Modal>
  );
};

export default CreatePoll;
